var _path;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgProfileAvatar = function SvgProfileAvatar(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 31,
    viewBox: "0 0 28 31",
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.3339 7.33333C21.3339 11.3834 18.0506 14.6667 14.0005 14.6667C9.95045 14.6667 6.6672 11.3834 6.6672 7.33333C6.6672 3.28325 9.95045 0 14.0005 0C18.0506 0 21.3339 3.28325 21.3339 7.33333ZM14.0005 17.2333C8.34904 17.2333 2.00596 20.5731 1.46054 21.725C1.01355 22.669 0.800537 25.575 0.800537 25.575C0.800537 26.636 2.56359 27.5 3.655 27.5H3.77655C5.62121 29.4538 9.50627 30.8 14.0005 30.8C18.4955 30.8 22.381 29.4534 24.2253 27.4991C25.3265 27.4683 27.2005 26.6165 27.2005 25.575C27.2005 25.575 26.9875 22.669 26.5405 21.725C25.9951 20.5731 19.652 17.2333 14.0005 17.2333Z",
    fill: "white"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgProfileAvatar, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/profile-avatar.2cb31e5c.svg";
export { ForwardRef as ReactComponent };